.container {
  height: 72px;
  width: 72px;
  min-height: 72px;
  min-width: 72px;
  padding: 16px;
  border: 1px solid var(--colors-grays-light);
  border-radius: var(--border-radius-lg);
}

.containerWithLogo {
  padding: 8px;
}

@media (--reefer-media-tablet-min) {
  .container {
    height: 96px;
    width: 96px;
    min-height: 96px;
    min-width: 96px;
    padding: 24px;
  }
}
